import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import search1 from "../../../../Components/Admin/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import Header from "../../Header/Header";
import { Context } from "../../../../utils/context";

import { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../../common/ModalDelete";
import { EditButton } from "../../../common/Button";
import { Permission } from "../../../../utils/permissions";

// *****************************************************************************************************

const Tables = () => {
  const { getData, deleteData, ErrorNotify, isAllow, Per_Page_Dropdown } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [searchContact, setSearchContact] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();

  const getDataAll = async () => {
    const response = await getData(
      `/masters/investor?page=${currentPage}&per_page=${perPage}&term=${search}&searchContact=${searchContact}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);

    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeStatus, perPage, reset, show, show1]);


  // Modal function
  const handleClose = () => setShowAdd(false);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [, setAllChecked] = useState([]);



  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);


  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/masters/employee/${recordToDeleteId}`,
      );

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Edit Investor"} link={"/masters/faq"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12  ">
            <section className="Tabels tab-radio tab-radio mt-3">
              <div className="">
                <div className="row">
                  <div className="d-flex"></div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-4">
                    <div className="  col-lg-4 col-md-4 col-12">
                      <div className="d-flex">
                        <div className="show me-2">
                          <p className="show mt-1">Show</p>
                        </div>
                        <div className="number me-2">
                          <select
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                            onChange={(e) => setperPage(e.target.value)}
                          >
                            {option?.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="entries">
                          <p className="show mt-1">entries</p>
                        </div>
                      </div>
                    </div>
                    <div className="  col-lg-8  col-md-8 col-12">
                      <div className="d-flex justify-content-end">
                        <div className="sowing me-2">
                          <p className="show mt-2">{`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1,
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.totalEntries,
                          )} of ${data?.data?.totalEntries} entries`}</p>
                        </div>
                        <div className="num me-2">
                          <input aria-label="Search"
                            type="text"
                            placeholder="First/Last Name"
                            className="form-control"
                            id=""
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                          />
                        </div>
                        <div className="num me-2">
                          <input
                            type="text"
                            placeholder="Contact"
                            className="form-control"
                            id=""
                            value={searchContact}
                            onChange={(e) => {
                              setSearchContact(e.target.value);
                            }}
                          />
                        </div>
                        <div className="Search me-2">
                          <button aria-label="Search"
                            type="button"
                            onClick={getDataAll}
                            className="btn btn-search"
                          >
                            <img src={search1} className="search" alt="" />
                          </button>
                        </div>

                        <div className="Search-1">
                          <button
                            type="button"
                            onClick={() => {
                              setSearch("");
                              setSearchContact("");
                              setReset(!reset);
                            }}
                            className="btn btn-reset"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-2"></div>
                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          <th className="sr">Sr. No.</th>
                          <th className="tax-name">First Name </th>
                          {/* {visible.col3 && (
                            <th className="tax-name">Last Name </th>
                          )} */}
                          <th className="tax-name">Email </th>
                          <th className="tax-name">Contact </th>
                          <th className="tax-name">Age </th>
                          <th className="tax-name">gender </th>
                          <th className="tax-name">Occupation </th>
                          <th className="tax-name">City </th>
                          <th className="active">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.data?.map((d, index) => {
                          return (
                            <tr className="" key={index}>
                              <td>{++index}.</td>
                              <td>{d?.f_name}</td>
                              {/* {visible.col5 && <td>{d?.l_name}</td>} */}
                              <td>{d?.email}</td>
                              <td>{d?.contact_no}</td>
                              <td>{d?.users_detail?.age}</td>
                              <td>{d?.users_detail?.gender}</td>
                              <td>{d?.users_detail?.occupation?.name}</td>
                              <td>{d?.users_detail?.city?.name}</td>

                              <td>
                                <div className="d-flex">
                                  {isAllow?.includes(Permission.Employee.Edit.name) ? (
                                    <EditButton
                                      handleShow1={handleShow1}
                                      id={d?.id}
                                    />
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
